import React from 'react';
import { Select } from 'antd';
import PropTypes from 'prop-types';
import { gradientColorStep } from '@utils/common';

const SelectOpt = Select.Option;

const colorSteps = gradientColorStep('#006CE2', '#FFB600', '#D04A02', 101);

const colors = {
  level0: '#434343', //default background color
  level1: '#80C4F5',
  level2: '#4DACF1',
  level3: '#0081E9',
};

const configs = [
  {
    colors: [colors.level0, colors.level0, colors.level0],
    text: 'In Progress',
  },
  {
    colors: [colors.level1, colors.level0, colors.level0],
    text: 'Low',
  },
  {
    colors: [colors.level1, colors.level2, colors.level0],
    text: 'Med',
    wholeText: 'Medium',
  },
  {
    colors: [colors.level1, colors.level2, colors.level3],
    text: 'High',
  },
];

const Dots = ({ colors }) => (
  <div className="dots-content">
    {colors.map((color, index) => (
      <div
        key={`color-${index}`}
        className="dot"
        style={{ backgroundColor: color }}
      />
    ))}
  </div>
);

const ColorfulDot = ({ percent }) => (
  <div className="colorful-dots-content">
    <div
      className="dot"
      style={{ background: colorSteps[parseInt(percent)] }}
    />
  </div>
);

// const renderLevelText = ({ percent }) => {
//   let level = percent < 34 ? ''
//   return (
//     <span className="text">
//       {wholeText
//         ? configs[complexityLevel].wholeText ||
//           configs[complexityLevel].text
//         : configs[complexityLevel].text}
//     </span>
//   )
// }

function ComplexityLevelIndicator({
  withoutColorful,
  level,
  percent,
  size,
  wholeText,
  selectMode = false,
  onChange,
}) {
  const complexityLevel = Number(level) ? level : 0;

  return (
    <div
      className={`complexity-indicator-wrapper  ${size} ${
        complexityLevel === 0 ? 'no-level' : ''
      }`}
    >
      {selectMode ? (
        <Select
          onChange={onChange}
          size={size}
          defaultValue={complexityLevel}
          getPopupContainer={() =>
            document.querySelector('.complexity-report-card-header')
          }
        >
          {(complexityLevel !== 0 ? configs.slice(1) : configs).map(
            (item, index) => (
              <SelectOpt
                key={item.text}
                value={complexityLevel !== 0 ? index + 1 : index}
              >
                {item.wholeText || item.text}
              </SelectOpt>
            ),
          )}
        </Select>
      ) : (
        <>
          {withoutColorful ? (
            <Dots colors={configs[complexityLevel].colors} />
          ) : (
            <ColorfulDot percent={percent || 0} />
          )}
          <span className="text">
            {wholeText
              ? configs[complexityLevel].wholeText ||
                configs[complexityLevel].text
              : configs[complexityLevel].text}
          </span>
        </>
      )}
    </div>
  );
}

ComplexityLevelIndicator.defaultProps = {
  size: 'small',
  selectMode: false,
  level: 0,
};

ComplexityLevelIndicator.propTypes = {
  level: PropTypes.oneOf([0, 1, 2, 3]),
  size: PropTypes.oneOf(['small', 'middle', 'large']),
  selectMode: PropTypes.bool,
};

export default ComplexityLevelIndicator;
